import { nameErrorMessage } from "../../lib/constants";

export const validateName = (value) => {
  let valid = true;
  let errorMessage = "";

  const names = value.split(" ");

  if (names.length < 2 || names[1] === "") {
    valid = false;
    errorMessage = nameErrorMessage;
  } else if (value.includes("?")) {
    valid = false;
    errorMessage = "Hmm, that does not look correct. Please enter in your name before asking your question";
  } else if (value.replace(/[^a-zA-Z ]/g, "").split(" ").length > 4) {
    valid = false;
    errorMessage = "That's too many words for a name";
  } else if (names[0].length < 2) {
    valid = false;
    errorMessage = "First name must be at least two characters";
  }

  return { valid, errorMessage };
};

export const personalizeMessage = (text, userFirstName, isWelcomeBackMessage) => {
  if (isWelcomeBackMessage) {
    return `Welcome Back ${userFirstName}`;
  }
  return text && text.replace(/{firstName}/gi, userFirstName);
};
